import {IconMenu} from "@bounce/shared/consumer/bounce-ui";
import {Colors, IconButton} from "@bounce/shared/ui";
import {Drawer} from "@mui/material";
import React, {ReactNode} from "react";

const DrawerMenu = ({children}: {children: ReactNode}) => {
  const [mobileOpen, setMobileOpen] = React.useState(false);
  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  return (
    <>
      <Drawer
        open={mobileOpen}
        onClose={handleDrawerToggle}
        ModalProps={{
          keepMounted: true,
        }}
        sx={{
          "& .MuiDrawer-paper": {
            width: 240,
            boxSizing: "border-box",
          },
        }}
      >
        {children}
      </Drawer>
      <IconButton onClick={handleDrawerToggle} sx={{position: "absolute", top: 8, left: 8}}>
        <IconMenu color={Colors.primary._800} />
      </IconButton>
    </>
  );
};
export default DrawerMenu;
